module.exports = __webpack_public_path__ + "static/staticAlternativesNo-212c46ab3842626644ac097f5274b6c0.png";